import type { UseDocumentProps } from '@ztechapps/common.hook'
import { useDocument } from '@ztechapps/common.hook'
import type { Product, ProductBillOfMaterial } from '@ztechapps/common.contract'
import { defaultProductFragment } from '../graphql'
import { jsonTryParse } from '@ztechapps/common.utils'
import { gql } from '@apollo/client'

const defaultQuery = gql`
  ${defaultProductFragment}
  query singleProdct($filter: JSON) {
    singleProduct(filter: $filter) {
      ...defaultProductFragment
    }
  }
`

export const useProductDocument = (props?: Partial<UseDocumentProps>) => {
  const documentResult = useDocument<Product>({
    query: defaultQuery,
    ...props,
  })

  function mergeBom() {
    const product = (documentResult?.document ?? {}) as Product
    const bomAsString = documentResult?.document?.fullBillOfMaterials

    if (!bomAsString) {
      return product
    }

    const _bom = jsonTryParse(bomAsString) as ProductBillOfMaterial[]
    const _product = {
      ...product,
      billOfMaterials: _bom,
    } as Product

    return _product
  }

  documentResult.document = mergeBom()
  return documentResult
}
